import { render, staticRenderFns } from "./NavBarParent.vue?vue&type=template&id=a675e608&scoped=true"
import script from "./NavBarParent.vue?vue&type=script&lang=js"
export * from "./NavBarParent.vue?vue&type=script&lang=js"
import style0 from "./NavBarParent.vue?vue&type=style&index=0&id=a675e608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a675e608",
  null
  
)

export default component.exports